import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  "businessTypeId": 2,
  "packageId": 1,
  "businessDetails": {
      "businessName": "xyz company",
      "designatorId": 1
  },
  "businessLocation": {
      "street": "mark lane",
      "city": "Arknsas",
      "state": "Colarado",
      "zipcode": "80010"
  },
  "primaryContact": {
      "fullName": "tony",
      "email": "tony@gmail.com"
  },
  "businessCategoryId": 1,
  "businessMembers": [
      {
          "firstName": "mark lane",
          "lastName": "Arknsas",
          "email": "Colarado@gmail.com",
          "ssnNumber": "80010",
          "ownership": "ownership"
      }
  ],
  "operationAgreementId": 1,
  "licenseReportId": 1,
  "lzBookKeepingId": 1,
  "expeditedProcessId": 1,
  "foundersKitId": 1,
  "taxExpertId": 1,
  "scorpId": 1,
  "questionnaire": [
      {
          "questionId": 1,
          "answerId": 1
      }
  ],
//   "payment": {
//       "paymentModeId": 1,
//       "paymentStructureId": 1,
//       "paymentStatusId": 1,
//       "paymentTransactionId": "",
//       "payer": {

//       },
//       "payee": {
        
//       }
//   },
  "totalAmount": {
      "subTotal": 0,
      "salesTax": 0,
      "filingFee": 0,
      "total": 0
  }
}

const llcSlice = createSlice({
  name: "llc",
  initialState: initialState,
  reducers: {
    update_business: (state, action) => {
      state.businessTypeId = action.payload;
    },
  },
});

export default llcSlice.reducer;
export const {update_name} = llcSlice.actions   
